import { HttpClient } from "@angular/common/http";
import { inject, Injectable, signal } from "@angular/core";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: 'root'
})

export class LoginService {

    private readonly _http = inject(HttpClient);

    //DATI MOCK LOGIN
    body = {
      token: 'GsNv571ggMDflO764qgqsC835t'
    }

    login(): Observable<any>{
    // return this._http.post<any>("/user-manage/auth/login", body);
    return of(this.body)
    }
}